module.exports = __webpack_public_path__ + "static/media/service-img-17.eaa1804a.jpg";